import t from '~/javascripts/utils/translation';
import { Component } from 'react';

class VirginiaClayCampaignPanel extends Component {
  render() {
    return (
      <div key={this.props.name}>
        <div className={`campaign panel closed ${this.props.name}`}>
          <div className='row'>
            <div className='large-12 medium-12 small-12 columns'>
              <h1 className='h60 text-grey-60'>
                {t(`d2p.${this.props.name}.campaign_name`)}
                <a data-modal='' href='#sponsor'>
                  <span className='icon cw-icon-star' />
                </a>
              </h1>
              <p
                className='p40 em campaigner-info'
                dangerouslySetInnerHTML={{
                  __html: t(`d2p.${this.props.name}.campaign_info`),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default VirginiaClayCampaignPanel;
